module.exports = __webpack_public_path__ + "img/image_preview.ad34acb4.png";